window.Facedr = window.Facedr || {};
window.Facedr.Accordion = function(el) {
  var $accordionBtn = $(el).find('.accordion__item__title');
  $accordionBtn.on('click', window.Facedr.Accordion.toggle.bind(this));
};

window.Facedr.Accordion.toggle = function(e) {
  var $clickedEl = $(e.target);
  var $parentItem = $clickedEl.parent();
  var accordionSpeed = 200;

  $('.accordion__item')
    .not($parentItem)
    .removeClass('is-active')
    .find('.accordion__item__content')
    .slideUp(accordionSpeed);

  if ($parentItem.hasClass('is-active')) {
    $parentItem
      .removeClass('is-active')
      .find('.accordion__item__content')
      .slideUp(accordionSpeed);
  } else {
    $parentItem
      .addClass('is-active')
      .find('.accordion__item__content')
      .slideDown(accordionSpeed);
  }
};
